import Vue from 'vue'
import VueI18n from 'vue-i18n'
import App from './App'
import router from './router'
import axios from './api'
// import VueSocketIO from 'vue-socket.io'
import AES from 'crypto-js/aes'
import Utf8 from 'crypto-js/enc-utf8'
import store from '@/store/index'
import lang from '@/assets/script/i18n/index'
import Util from '@/util/Util'
import '@/UIO/index' // 自定义组件套件
import showToast from '@/UIO/Toast/index'
import vuescroll from 'vuescroll' // 自定义滚动条
import { writeLog } from '@/api/index'
import emitter from './ui/src/mixins/emitter'
import ElementUI from 'element-ui'
import ui from '@/ui'
import watchImg from './ui/src/mixins/watchImg'
import '@/ui/src/utils/cascader/index.css'
import joinClass from '@/components/Stu/JoinClass'
import checkLocalTime from '@/components/Stu/checkLocalTime'
import queueUp from '@/components/Stu/queueUp'
import '../theme/index.css'
import receivingInformation from '@/components/Stu/receivingInformation'
import submitProcess from '@/components/Stu/StuPractice/StuExam/submitProcess'

Vue.config.productionTip = false

Vue.use(VueI18n)
Vue.use(vuescroll)
Vue.use(axios)
Vue.use(ElementUI)
Vue.use(ui)
Vue.use(joinClass)
Vue.use(checkLocalTime)
Vue.use(queueUp)
Vue.use(receivingInformation)
Vue.use(submitProcess)

// 2020.08.06 线上没开 所以注释websocket
// Vue.use(new VueSocketIO({
//   debug: true,
//   connection: location.origin,
//   // connection: localStorage.getItem('zyUrl'),
//   // vuex: {
//   //   store,
//   //   mutationPrefix: 'SOCKET_',
//   //   actionPrefix: 'SOCKET_'
//   // }
// }))

const i18n = new VueI18n({
  locale: 'zh',
  messages: lang
})
Vue.prototype.$AES = AES
Vue.prototype.$Utf8 = Utf8
Vue.prototype.$util = Util
Vue.prototype.$toast = showToast
Vue.prototype.$vuescrollConfig = {
  rail: {
    vRail: {
      width: '4px'
    },
    hRail: {
      height: '4px'
    }
  },
  bar: {
    vBar: {
      background: '#75d6a8'
    },
    hBar: {
      background: '#75d6a8'
    }
  }
}

Vue.prototype.$winOpen = url => {
  return window.open(url, window.ConfigNew.header.title)
}

Vue.mixin({
  methods: {
    replaceAnswer(answer) {
      return answer.replace(/[^0-9a-zA-Z\u4e00-\u9fa5]+/g, ' ').trim().toLowerCase()
    },
    compareAnswer(myAnswer, standardAnswer) {
      return this.replaceAnswer(myAnswer) === this.replaceAnswer(standardAnswer)
    },
    getNavHeight(diff, defaultHeight) {
      const dom = document.getElementById('nav')
      if (dom) {
        return (
          document.getElementById('nav').getBoundingClientRect().height - (diff || 0) + 'px'
        )
      } else {
        return defaultHeight + 'px'
      }
    },
    writeLog(params) {
      let _params = Object.assign({}, params, {
        pushParam: {
          gradeName: this.$store.state.student.grade,
          className: this.$store.state.student.clazz
        }
      })
      writeLog(_params)
    },
    requestFail(res, addons) {
      let _cfg = {
        errText: res.info,
        btnText: this.$t('dialog.iknow')
      }
      this.$store.commit(
        'showErrDialog',
        Object.assign({}, _cfg, typeof addons === 'object' && addons)
      )
    }
  }
})
Vue.mixin(emitter)
Vue.mixin(watchImg)
async function init() {
  if (window.location.href.match(/linshi/) && window.location.href.match(/uid/)) {
    if (window.location.pathname.match(/linshi/)) {
      var linshiLogin = await import('./linshi_login.js')
      linshiLogin.default(Vue.prototype.$http, () => {
        localStorage.setItem('isLsStu', '1')
        render()
      })
    } else {
      localStorage.setItem('isLsStu', '1')
      render()
    }
  } else if (process.env.NODE_ENV === 'development') {
    var a = await import('./develop_login.js')
    await a.default(Vue.prototype.$http)
    render()
  } else {
    localStorage.setItem('isLsStu', '0')
    render()
  }
}
router.beforeEach((to, from, next) => {
  // 领事的学生
  if (localStorage.getItem('isLsStu') === '1' && /^\/stu\//.test(to.path)) {
    next(to.path.replace(/^\/stu\//, '/linshi/'))
  } else {
    next(); // 允许正常访问
  }
});

Vue.directive('focus', {
  // 添加input自动获取焦点指令
  inserted: el => {
    el.focus()
  }
})

function render() {
  window.vm = new Vue({
    el: '#app',
    router,
    store,
    i18n,
    components: {
      App
    },
    template: '<App/>'
  })
}

init()



// WEBPACK FOOTER //
// ./src/main.js